import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

class Header extends React.Component {
  render() {
    return (
      <Navbar
        collapseOnSelect
        expand="lg"
        className="base-color custom-navbar"
        variant="dark"
      >
        <Container>
          <Navbar.Brand href="/">
            <b className="font-PoppinsBold">@Wizzfun</b>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto" />
            <Nav className="ml-auto">
              <Nav.Link href="/articles" className="text-light">
                <button type="button" className="btn btn-base">
                  Articles
                </button>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default Header;
